import React, { useState, useEffect } from 'react';
import { constData } from '../../../const/Const';
import { API } from '../../../API/API';
import GridDefaultShimmer from '../../../components/GridDefaultShimmer/GridDefaultShimmer';
import PageHeader from '../../../components/PageHeader/PageHeader';
import EmpNew from './New/EmpNew';
import { DetailsRow } from '@fluentui/react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ColEdit from '../../../components/ColEdit/ColEdit';
import { getFilter } from '../../../SharedFunc/FilterAndSearch.js';
import InitSetupPage from '../../InitSetupPage/InitSetupPage';
import { useContext } from 'react';
import { UserContext } from '../../../context/UserContext';
import { isEdit } from '../../../SharedFunc/User';
import Warning from '../../../components/Warning/Warning';
import ButtonIcon from '../../../components/ButtonIcon/ButtonIcon';
import { Space, message } from 'antd';
import WorkiLogo from '../../../images/workiLogo.png';
import LoadSpin from '../../../components/LoadSpin/LoadSpin';

const Employees = (props) => {

    const navigate = useNavigate();

    const { userInfo } = useContext(UserContext);

    const [data, setData] = useState([]);
    const [oData, setOData] = useState([]);

    const [dataInActive, setDataInActive] = useState([]);

    const [filterValue, setFilterValue] = useState('ACTIVE');
    const [loading, setLoading] = useState(false);
    const [filterData] = useState(constData.hrEmployee_Status);
    const [showEmpNew, setShowEmpNew] = useState(false);
    const [gridFilter, setGridFilter] = useState([]);
    const [searchParams] = useSearchParams();
    const [showSetup, setShowSetup] = useState(false);

    const [loadingButton, setLoadingButton] = useState(false);

    const [edit] = useState(isEdit(userInfo?.accesstoken, ["HR"]));

    const [columnDraft] = useState([
        {
            name: 'Нэр',
            fieldName: 'firstname',
            isBold: true,
            isCapitalize: true,
            maxWidth: 160,
            onRender: (item) => {
                if (edit) {
                    return (
                        <ColEdit onClick={() => onPressEmp(item.empid)}>{item.firstname}</ColEdit>
                    );
                } else {
                    return item?.firstname;
                }
            }
        },
        {
            name: 'Эцэг/эхийн нэр',
            fieldName: 'lastname',
            isBold: true,
            isCapitalize: true,
            maxWidth: 160
        },
        {
            name: 'Регистрийн дугаар',
            fieldName: 'regno',
            maxWidth: 160
        },
        {
            name: 'Төлөв',
            fieldName: 'statusname',
            maxWidth: 80,
            filter: true
        },
        {
            name: 'Гар утас',
            fieldName: 'mobilephone',
            minWidth: 60
        },
        {
            name: 'И-мэйл (Албан)',
            fieldName: 'email',
            minWidth: 180
        }
    ]);

    const [columns] = useState([
        {
            name: 'Нэр',
            fieldName: 'firstname',
            isBold: true,
            isCapitalize: true,
            maxWidth: 160,
            onRender: (item) => {
                if (edit) {
                    return (
                        <ColEdit onClick={() => onPressEmp(item.empid)}>{item.firstname}</ColEdit>
                    );
                } else {
                    return item?.firstname;
                }
            }
        },
        {
            name: 'Эцэг/эхийн нэр',
            fieldName: 'lastname',
            isBold: true,
            isCapitalize: true,
            maxWidth: 160
        },
        {
            name: 'Регистрийн дугаар',
            fieldName: 'regno',
            maxWidth: 160
        },
        {
            name: 'Төлөв',
            fieldName: 'statusname',
            maxWidth: 80,
            filter: true
        },
        {
            name: 'Дотоод нэгж',
            fieldName: 'departmentname',
            minWidth: 250
        },
        {
            name: 'Ажлын байр',
            fieldName: 'positionname',
            minWidth: 120
        },
        {
            name: 'Гар утас',
            fieldName: 'mobilephone',
            minWidth: 60
        },
        {
            name: 'И-мэйл (Албан)',
            fieldName: 'email',
            minWidth: 180
        }
    ]);

    const getData = async (p_filtervalue, p_gridfilter) => {

        let filtercolumns = getFilter(p_gridfilter, searchParams.get('filter'));

        let tData = [];
        let tDataInActive = [];

        setLoading(true);

        try {
            await API.post('/api/humanresource/employee/get_employee_list', {
                "status": p_filtervalue,
                "filtercolumns": filtercolumns
            }).then(response => {
                if (response.status === 200 && response.data.rettype === 0) {
                    if (response.data?.retdata?.length > 0) {
                        tData = response.data.retdata;
                    }
                }
            });


            await API.post('/api/humanresource/employee/get_employee_list', {
                "status": 'RG',
                "filtercolumns": []
            }).then(response => {
                if (response.status === 200 && response.data.rettype === 0) {
                    if (response.data?.retdata?.length > 0) {
                        tDataInActive = response.data.retdata;
                    }
                }
            });

            await API.get('api/humanresource/Organization/get_is_new_company?companyid=' + userInfo?.companyid).then(response => {
                if (response.status === 200 && response.data.rettype === 0) {
                    setShowSetup(response?.data?.retdata ? true : false);
                }
            });

        } finally {
            setLoading(false);
        }

        setOData(tData);
        setData(tData);
        setDataInActive(tDataInActive);
    }

    const getGridFilterData = async () => {
        let tGridFilter = [];
        await API.get('/api/humanresource/employee/get_employee_list_filter_data').then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                if (response.data?.retdata?.length > 0) {
                    tGridFilter = response.data.retdata;
                }
            }
        });
        setGridFilter(tGridFilter);
    }

    useEffect(() => {
        getData("ACTIVE");
        getGridFilterData();
    }, []);



    const changeFilter = (p_key, p_name) => {
        setFilterValue(p_key);
        getData(p_key);
    }

    const onPressEmp = (p_empid) => {
        navigate('/hrsuite/employee/' + p_empid);
    }

    const onNew = () => {
        navigate('/hrsuite/employee/-1?tab=basic');
    }

    const onDismissEmpNew = () => {
        setShowEmpNew(false);
    }

    const onAfterSave = () => {
    }

    const onSearch = (p_data) => {
        setData(p_data);
    }

    const onGridFilterChange = async (p_gridfiltervalue) => {
        getData(filterValue, p_gridfiltervalue);
    }

    const onWorki = async () => {
        if (userInfo?.features.includes("WORKI")) {
            let tWorkiData = [];
            try {
                setLoadingButton(true);

                await API.get('/api/humanresource/employee/worki/getWorkiEmps').then(response => {
                    if (response.status == 200 && response.data.rettype == 0) {
                        if (response.data?.retdata?.length > 0) {
                            tWorkiData = response.data?.retdata;
                        }
                    }
                }).catch(error => {
                    if (error?.response?.status === 402)
                        navigate("/hrsuite/market/6");
                });

                if (tWorkiData?.length > 0) {
                    navigate('/excelimportemp?pagetype=worki', { state: tWorkiData });
                } else {
                    message.warning("Мэдээлэл олдсонгүй!");
                }

            } finally {
                setLoadingButton(false);
            }
        } else {
            navigate("/hrsuite/market/6");
        }
    }

    return (
        <div>
            {dataInActive?.length > 0 && (
                <div>
                    <div style={{ marginTop: 20, marginLeft: 16, marginRight: 16 }}>
                        <Warning value='"Ажиллаж байгаа" болгохын тулд нэр дээр нь дарж ороод "Ажилд авсан түүх" бүртгээрэй.' zeroMargin />
                    </div>
                    <PageHeader
                        buttonTitle=""
                        title="Бүртгэсэн төлөвтэй"
                        onButtonClick={() => { }}
                        dataCount={dataInActive.length}
                        gridFilter={() => { }}
                        onGridFilterChange={() => { }}
                        loading={loading}
                    />
                    <GridDefaultShimmer
                        setKey='empid'
                        loading={loading}
                        columns={columnDraft}
                        data={dataInActive}
                        onRenderRow={(rowProps) => {
                            let vStyle = {};
                            if (rowProps?.item?.emptype == "C") {
                                vStyle.root = { backgroundColor: 'rgba(255, 200, 10, 0.08)' };
                            }
                            return <DetailsRow {...rowProps} styles={vStyle} />
                        }}
                    />
                </div>
            )}
            <PageHeader
                showLeftFilter
                changeFilter={changeFilter}
                filterValue={filterValue}
                filterData={filterData}
                buttonTitle={edit ? "Ажилтан нэмэх" : null}
                title="Ажилтны жагсаалт"
                onButtonClick={onNew}
                dataCount={data.length}
                columns={columns}
                data={oData}
                filteredData={data}
                onSearch={onSearch}
                gridFilter={gridFilter}
                onGridFilterChange={onGridFilterChange}
                loading={loading}
                addButton={edit ?
                    <Space>
                        <ButtonIcon text="Excel-ээс нэмэх" iconName='Add' onClick={() => { navigate('/excelimportemp'); }} />
                        {loadingButton ? <LoadSpin /> : <ButtonIcon text="Worki ажилтан татах" img={<img width={20} height={20} src={WorkiLogo} />} onClick={onWorki} />}
                    </Space>
                    : null}
            />
            <div>
                <GridDefaultShimmer
                    setKey='empid'
                    loading={loading}
                    columns={columns}
                    data={data}
                    onRenderRow={(rowProps) => {
                        let vStyle = {};
                        if (rowProps?.item?.emptype == "C") {
                            vStyle.root = { backgroundColor: 'rgba(255, 200, 10, 0.08)' };
                        }
                        return <DetailsRow {...rowProps} styles={vStyle} />
                    }}
                />
            </div>
            <EmpNew headerText="Ажилтан нэмэх" isOpen={showEmpNew} onDismiss={onDismissEmpNew} afterSave={onAfterSave} />
            <InitSetupPage
                isOpen={showSetup}
                onDismiss={() => {
                    setShowSetup(false);
                }}
                afterSave={() => {
                    setShowSetup(false);
                    getData("ACTIVE");
                }}
            />
        </div>
    );
}

export default Employees;